<template>
  <auth-layout>
    <code-step
      title="Check your inbox"
      :verify="verify"
      :resend-code="resend"
      :resend-available-at="signup.resendAvailableAt"
      :locked-until="signup.lockedUntil"
      @verified="onVerified"
      @expired="onExpired"
      @resend-at="$store.commit('signup/patch', { resendAvailableAt: $event })"
      @locked-until="$store.commit('signup/patch', { lockedUntil: $event })"
    >
      <template #intro>
        We sent a 6-digit code to <b>{{ signup.email }}</b>. Enter it here to verify your email.
        <router-link class="pop-auth__link" :to="{ path: '/register', query: { email: signup.email } }">Wrong address?</router-link>
      </template>
    </code-step>
  </auth-layout>
</template>

<script>
import AuthLayout from '../AuthLayout.vue'
import CodeStep from '../CodeStep.vue'
import { finishLogin, trackGoogleSignupConversion } from '../session'
import { getDeviceId } from '@/utils/device-id'
import { segmentPage } from '@/utils'

export default {
  name: 'SignupVerifyPage',
  components: { AuthLayout, CodeStep },
  computed: {
    signup() {
      return this.$store.state.signup
    },
  },
  created() {
    if (!this.signup.pendingToken) {
      this.$router.replace('/register')
      return
    }
    segmentPage('SignupVerify', { email: this.signup.email })
  },
  methods: {
    async verify(code) {
      const response = await this.$store.dispatch('signupVerify', {
        pendingToken: this.signup.pendingToken,
        code,
        deviceId: getDeviceId(),
      })
      return response.data
    },
    async resend() {
      const response = await this.$store.dispatch('signupResend', { pendingToken: this.signup.pendingToken })
      return response.data
    },
    onVerified(data) {
      this.$store.commit('signup/clearPending')
      trackGoogleSignupConversion()
      // Plans next: straight to checkout when a plan came with the signup link, else the picker.
      const redirect = this.signup.plan && this.signup.plan.code ? '/plans/checkout' : '/plans'
      finishLogin(this, { token: data.token, user: data.user }, {
        event: 'signup_verified',
        eventData: { method: 'password', entry: this.signup.entry },
        redirect,
      })
    },
    onExpired() {
      this.$store.commit('signup/clearPending')
      this.$notify({ group: 'info', type: 'warning', text: 'This signup expired. Please start again.' })
      this.$router.replace({ path: '/register', query: { email: this.signup.email, expired: '1' } })
    },
  },
}
</script>
